module.exports = __webpack_public_path__ + "static/media/noHistory.923b2030.svg";